/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Preview_HintInputs */

const cs_templates_preview_hint = /** @type {(inputs: Templates_Preview_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sestaví ukázková data do PDF náhledu (bez kreditů).`)
};

const en_templates_preview_hint = /** @type {(inputs: Templates_Preview_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compiles sample data into a PDF preview (no credits).`)
};

/**
* | output |
* | --- |
* | "Compiles sample data into a PDF preview (no credits)." |
*
* @param {Templates_Preview_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_preview_hint = /** @type {((inputs?: Templates_Preview_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Preview_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_preview_hint(inputs)
	return cs_templates_preview_hint(inputs)
});